export default __webpack_public_path__ + "static/media/js.3abb3de3.png";